module.exports = __webpack_public_path__ + "static/media/rsz_arbitrum.3b29c908.webp";